var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","background-color":"transparent"}},[(_vm.$apollo.loading && !_vm.table._id)?_c('Loading'):[_c('v-tabs-items',{staticStyle:{"height":"calc(100% - 52px)"},attrs:{"id":"table-edit__tabs-items"},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},[_c('v-tab-item',{staticStyle:{"height":"100%"},attrs:{"value":"component"}},[_c('Fields',{attrs:{"id":"table-edit__component-tab-fiels","schema":{
            name: {
              type: 'string',
              label: 'Nombre',
              description: 'Debe ser único y reconocible.',
              sizeSmall: 12,
              sizeLarge: 6,
              newDesign: true
            },
            title: {
              type: 'string',
              label: 'Título',
              description: 'Opcional. Se mostrará en las vistas.',
              sizeSmall: 12,
              sizeLarge: 6,
              optional: true,
              newDesign: true
            },
            roles: {
              type: 'roleSelect',
              __graphQLType: '[ID]',
              label: 'Roles',
              fieldOptions: {
                multi: true
              },
              optional: true,
              newDesign: true
            },
            collectionId: {
              type: 'collectionSelect',
              label: 'Colección',
              fieldOptions: {
                disabled: true,
                readonly: true
              },
              newDesign: true
            },
            orderByDefault: {
              type: 'collectionFieldSelect',
              label: 'Campo a ordenar por defecto',
              optional: true,
              newDesign: true
            },
            cssClassField: {
              type: 'collectionFieldSelect',
              label: 'Campo a usar para clases CSS',
              description:
                'El valor de este campo en cada fila se añade al class, permitiendo estilos personalizados',
              optional: true,
              newDesign: true
            },
            /*
            fixedHeaders: {
              type: 'checkbox',
              label: 'Usar cabeceras fijas',
              optional: true
            },
            */
            orderByAsc: {
              type: 'checkbox',
              label: 'Orden ascendente por defecto',
              optional: true,
              newDesign: true
            },
            sortable: {
              type: 'checkbox',
              label:
                'Permitir arrastrar elementos (debe seleccionarse un campo a ordenar tipo número)',
              optional: true,
              newDesign: true
            },
            disableRefresh: {
              type: 'boolean',
              fieldType: 'checkbox',
              label: 'Desactivar auto-actualización',
              optional: true,
              newDesign: true
            }
          },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId },"validationErrors":{}},model:{value:(_vm.table),callback:function ($$v) {_vm.table=$$v},expression:"table"}}),_c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":true}},[(_vm.table.collectionId)?_c('v-col',{attrs:{"cols":"12"}},[_c('ComponentSelect',{key:"filtersIds",staticClass:"pa-1",attrs:{"name":"filtersIds","schema":{
                  label: 'Filtros',
                  fieldOptions: {
                    multi: true,
                    componentTypeName: 'filters',
                    filterByKey: 'collectionId',
                    filterByValue: _vm.table.collectionId
                  },
                  newDesign: true
                },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId }},model:{value:(_vm.table.filtersIds),callback:function ($$v) {_vm.$set(_vm.table, "filtersIds", $$v)},expression:"table.filtersIds"}})],1):_vm._e(),(
                _vm.table.collectionId &&
                _vm.table.filtersIds &&
                _vm.table.filtersIds.length > 1
              )?_c('v-col',{attrs:{"cols":"12"}},[_c('ComponentSelect',{key:"filterByDefault",staticClass:"pa-1",attrs:{"name":"filterByDefault","schema":{
                  label: 'Filtro por defecto',
                  fieldOptions: {
                    componentTypeName: 'filters',
                    filterByKey: '_id',
                    filterByValue: _vm.table.filtersIds
                  }
                },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId }},model:{value:(_vm.table.filterByDefault),callback:function ($$v) {_vm.$set(_vm.table, "filterByDefault", $$v)},expression:"table.filterByDefault"}})],1):_vm._e(),(_vm.table.filtersIds && _vm.table.filtersIds.length)?_c('v-col',{staticClass:"pa-1",attrs:{"cols":"12"}},[_c('v-checkbox',{key:"allowsNoFilter",staticClass:"my-2",attrs:{"label":"Se puede usar sin filtro","hide-details":"auto"},model:{value:(_vm.table.allowsNoFilter),callback:function ($$v) {_vm.$set(_vm.table, "allowsNoFilter", $$v)},expression:"table.allowsNoFilter"}})],1):_vm._e(),(_vm.table.filtersIds && _vm.table.filtersIds.length > 1)?_c('v-col',{staticClass:"pa-1",attrs:{"cols":"12"}},[_c('v-checkbox',{key:"orderFiltersByName",staticClass:"my-2",attrs:{"label":"Ordenar filtros alfabéticamente","hide-details":"auto"},model:{value:(_vm.table.orderFiltersByName),callback:function ($$v) {_vm.$set(_vm.table, "orderFiltersByName", $$v)},expression:"table.orderFiltersByName"}})],1):_vm._e(),_c('v-col',{staticClass:"pa-1",attrs:{"cols":"12"}},[_c('v-checkbox',{key:"exportable",staticClass:"my-2",attrs:{"label":"La tabla es exportable","hide-details":"auto"},model:{value:(_vm.table.exportable),callback:function ($$v) {_vm.$set(_vm.table, "exportable", $$v)},expression:"table.exportable"}})],1),(_vm.table.exportable)?_c('v-col',{staticClass:"pa-1",attrs:{"cols":"12"}},[_c('v-checkbox',{key:"exportWithId",staticClass:"my-2",attrs:{"label":"Incluir IDs en exportable","hide-details":"auto"},model:{value:(_vm.table.exportWithId),callback:function ($$v) {_vm.$set(_vm.table, "exportWithId", $$v)},expression:"table.exportWithId"}})],1):_vm._e(),_c('v-col',{staticClass:"pa-1",attrs:{"cols":"12"}},[_c('v-checkbox',{key:"unlimited",staticClass:"my-2",attrs:{"label":"Sin límite de items por página","hide-details":"auto"},model:{value:(_vm.table.unlimited),callback:function ($$v) {_vm.$set(_vm.table, "unlimited", $$v)},expression:"table.unlimited"}})],1),(!_vm.table.unlimited)?_c('v-col',{staticClass:"pa-1",attrs:{"cols":"12"}},[_c('v-slider',{key:"defaultLimit",staticClass:"my-2",attrs:{"label":"Cantidad de items a mostrar por defecto","min":"5","max":"200","thumb-label":"","ticks":"always","step":"5","hide-details":"auto"},model:{value:(_vm.table.defaultLimit),callback:function ($$v) {_vm.$set(_vm.table, "defaultLimit", $$v)},expression:"table.defaultLimit"}})],1):_vm._e()],1)],1)],1),_c('v-tab-item',{staticStyle:{"height":"100%"},attrs:{"value":"columns"}},[_c('TableFields',{attrs:{"name":"fields","errorMessages":"","environmentVariables":{
            environmentId: _vm.environmentId,
            collectionId: _vm.table.collectionId,
            componentId: _vm.componentId
          }},model:{value:(_vm.table.fields),callback:function ($$v) {_vm.$set(_vm.table, "fields", $$v)},expression:"table.fields"}})],1),_c('v-tab-item',{staticStyle:{"height":"100%"},attrs:{"value":"footer"}},[_c('TableFooter',{attrs:{"name":"footer","errorMessages":"","environmentVariables":{
            environmentId: _vm.environmentId,
            collectionId: _vm.table.collectionId,
            componentId: _vm.componentId
          }},model:{value:(_vm.table.footer),callback:function ($$v) {_vm.$set(_vm.table, "footer", $$v)},expression:"table.footer"}})],1)],1),_c('v-card-actions',[_c('v-btn',{attrs:{"text":"","icon":"","color":"error","disabled":_vm.$apollo.loading || _vm.saving,"title":"Eliminar Tabla"},on:{"click":_vm.deleteItem}},[_c('v-icon',[_vm._v("delete")])],1),_c('v-btn',{attrs:{"text":"","icon":"","title":"Revertir Cambios","disabled":!_vm.dirty || _vm.saving},on:{"click":_vm.update}},[_c('v-icon',[_vm._v("undo")])],1),_c('v-flex'),_c('v-btn',{attrs:{"color":"#59a4f4","dark":"","disabled":_vm.$apollo.loading || _vm.saving},on:{"click":_vm.dismiss}},[_vm._v("Cancelar")]),_c('v-btn',{attrs:{"color":"#59a4f4","dark":!_vm.dirty ? false : true,"disabled":!_vm.dirty,"loading":_vm.$apollo.loading || _vm.saving},on:{"click":_vm.save}},[_vm._v("Guardar")])],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }